import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import AboutSection from '@/components/feature/sections/AboutSection'
import WhyUsSection from '@/components/feature/sections/WhyUsSection'
import ProcessSection from '@/components/feature/sections/ProcessSection'
import TestimonialsSection from '@/components/feature/sections/TestimonialsSection'
import CtaBand from '@/components/feature/CtaBand'

export default function About() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <PageHeader
        breadcrumb={t('pages.about.breadcrumb')}
        label={t('pages.about.label')}
        title={t('pages.about.title')}
        description={t('pages.about.description')}
        image="https://readdy.ai/api/search-image?query=warm%20cinematic%20photography%20studio%20interior%20with%20framed%20portraits%20on%20the%20wall%2C%20vintage%20cameras%20on%20a%20wooden%20shelf%2C%20golden%20ambient%20lighting%2C%20deep%20brown%20and%20amber%20tones%2C%20premium%20editorial%20atmosphere%2C%20soft%20shadows&width=1920&height=900&seq=shabi-hdr-about&orientation=landscape"
        imageAlt="Shabi Media photography studio with framed portraits and warm golden light"
      />
      <AboutSection />
      <WhyUsSection />
      <ProcessSection />
      <TestimonialsSection />
      <CtaBand
        eyebrow={t('cta.about.eyebrow')}
        title={t('cta.about.title')}
        description={t('cta.about.description')}
      />
    </SiteLayout>
  )
}